<template>
  <div class="metadata-rows">
    <p v-if="!rows.length" class="bridge-muted">{{ emptyText }}</p>
    <div v-for="(row, index) in rows" :key="row.id" class="metadata-row">
      <aha-input
        aria-label="Key"
        placeholder="Key"
        :value="row.key"
        :disabled.prop="busy"
        @input="row.key = detailValue($event, row.key)"
      ></aha-input>
      <aha-input
        aria-label="Value"
        placeholder="Value"
        :value="row.value"
        :disabled.prop="busy"
        @input="row.value = detailValue($event, row.value)"
      ></aha-input>
      <aha-button icon-only size="xs" variant="tertiary" aria-label="Remove row" :disabled="busy" @click="rows.splice(index, 1)">
        <aha-icon name="system-x" size="14" decorative></aha-icon>
      </aha-button>
    </div>
    <div>
      <aha-button size="sm" variant="secondary" :disabled="busy" @click="addRow">Add key</aha-button>
    </div>
    <aha-alert v-if="validationError" type="warning" size="small">{{ validationError }}</aha-alert>
  </div>
</template>

<script>
import { detailValue } from './catalogMixin'
import nativeAhaElements from './nativeAhaElements'

let rowCounter = 0

export default {
  name: 'StripeBridgeMetadataRows',
  components: { ...nativeAhaElements },
  props: {
    original: { type: Object, default: () => ({}) },
    busy: { type: Boolean, default: false },
    emptyText: { type: String, default: 'No metadata yet.' },
  },
  data() {
    return { rows: [] }
  },
  computed: {
    keptRows() {
      return this.rows.filter(row => row.key.trim() || row.value.trim())
    },
    validationError() {
      const keys = this.keptRows.map(row => row.key.trim())
      if (keys.some(key => !key)) return 'Every value needs a key.'
      if (this.keptRows.some(row => !row.value.trim())) return 'Every key needs a value. Remove the row to unset a key.'
      if (new Set(keys).size !== keys.length) return 'Each key can only appear once.'
      if (keys.some(key => key.length > 40)) return 'Keys can be at most 40 characters.'
      return ''
    },
    payload() {
      const next = Object.fromEntries(this.keptRows.map(row => [row.key.trim(), row.value]))
      const removed = Object.keys(this.original).filter(key => !(key in next))
      return { ...Object.fromEntries(removed.map(key => [key, ''])), ...next }
    },
    changed() {
      return Object.entries(this.payload).some(([key, value]) => (this.original[key] === undefined ? '' : this.original[key]) !== value)
    },
    state() {
      return { payload: this.payload, changed: this.changed, validationError: this.validationError }
    },
  },
  watch: {
    original: {
      immediate: true,
      handler(value, previous) {
        if (previous && JSON.stringify(value || {}) === JSON.stringify(previous || {})) return
        this.rows = Object.entries(value || {}).map(([key, entry]) => this.newRow(key, String(entry)))
      },
    },
    state: {
      immediate: true,
      handler(value) {
        this.$emit('change', value)
      },
    },
  },
  methods: {
    newRow(key, value) {
      rowCounter += 1
      return { id: rowCounter, key, value }
    },
    addRow() {
      this.rows.push(this.newRow('', ''))
    },
    detailValue,
  },
}
</script>

<style lang="scss" scoped>
@import './bridgeStyles.scss';

.metadata-rows {
  display: flex;
  flex-direction: column;
  gap: var(--aha-space-8);
}

.metadata-row {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: var(--aha-space-8);
  align-items: center;
}
</style>
